import React from "react";

function AppAlertMessage(props) {
  if (props.status == "success") {
    return (
      <div className="alert alert-success" role="alert">
        <i className="fa fa-check-circle" aria-hidden="true"></i> {props.message}
      </div>
    );
  } else if (props.status == "failure") {
    return (
      <div className="alert alert-danger" role="alert">
        <i className="fa fa-times-circle" aria-hidden="true"></i> {props.message}
      </div>
    );
  }
  return null;
}

export default AppAlertMessage;
